import React from 'react';

import styles from './InfoCard.module.scss';

interface IProps {
  title: string;
  desc: string;
  // anchor?: string;
  onClick?: () => void;
}

function InfoCard(props: IProps) {
  const { title, desc, onClick } = props;

  const handleClick = () => {
    onClick?.();
  };

  return (
    <div className={styles.container} onClick={handleClick}>
      <span className={styles.title}>{title}</span>
      <p className={styles.desc}>{desc}</p>
    </div>
  );
}

export default InfoCard;
